export enum NavigationActionTypes {
    TOGGLE_LEFT_MENU = 'TOGGLE_LEFT_MENU',
    TOGGLE_RIGHT_MENU = 'TOGGLE_RIGHT_MENU'
}

export interface NavigationState {
    leftMenuOpen: boolean;
    rightMenuOpen: boolean;
}

export interface LocationState {
    from: string;
}
